/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import '@/utils/paths.js'
import i18n from './lang/il8n.js'
import './permission.js'
import './filters'
import '@/utils/validate.js'
import '@/utils/tips.js'
import '@/utils/date.js'
import $ from 'jquery'
import store from './store'
import * as socketApi from '@/utils/socket'

// import $ from 'jquery'
import '@/assets/less/app.less'
import '@/assets/style.css'
import '@/assets/css/page.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import vueToTop from 'vue-totop'
Vue.use(vueToTop)
import * as echarts from 'echarts'
import utils from '@/utils/utils'
Vue.use(utils)
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.prototype.socketApi = socketApi
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
import VueAxios from 'vue-axios'
Vue.use(VueAxios,axios)
import router from './router'
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js